<app-header></app-header>
<!-------Home banner Game-------->
<div class="container mt10">
    <owl-carousel-o [options]="customOptionsOwl">
        <ng-container *ngFor="let hsl of homeSliderData; let i= index">
            <ng-template carouselSlide *ngFor="let tb of hsl.content; let i= index">
                <a [routerLink]="['/game-play/', tb.gameid, 'home']" (click)="
                    downloadLog(tb.displayname);">
                    <img src="{{tb.imageurl}}" class="round-corner">
                </a>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>

<div *ngIf="subbtn">
    <a type="button" class="btn-play sub" (click)="click()">SUBSCRIBE @ 1 DAY FREE TRAIL</a>
</div>

<!-------Trending Game-------->
<div *ngFor="let tgd of trendingGamesData; let i= index">
    <div class="container">
        <div class="row">
            <div class="col-xs-10">
                <div class="title">{{tgd.categoryname}}</div>
            </div>
            <div class="col-xs-2 right mt10"><a [routerLink]="['/view-games/', tgd.categoryid, tgd.categoryname]"
                    class="more">More</a></div>
        </div>
    </div>
    <div class="container mt10">
        <!-- <owl-carousel-o [options]="gamesOwl">
            <ng-container *ngFor="let tg of tgd.content; let i= index">
                <ng-template carouselSlide> -->

        <div class="row" *ngFor="let tg of tgd.content; let i= index">
            <div class="col-xs-4 mt20">
                <a [routerLink]="['/game-play/', tg.gameid, 'home']" (click)="downloadLog(tg.displayname);">
                    <img src="{{tg.previewurl}}" class="round-corner game-icon" width="100%">
                </a>
            </div>
            <div class="col-xs-8 mt20">
                <div class="game-title">{{tg.displayname}}</div>
                <div class="rating">★★★</div>
                <div class="desc" (click)="discribModal(i, tg.description)">{{tg.description}}</div>
                <a href="#" [routerLink]="['/game-play/', tg.gameid, 'home']" class="btn-play"
                    (click)="downloadLog(tg.displayname);">play
                    now</a>
            </div>
            <div class="popup-dis" *ngIf="discrib">
                <div class="modal-dialog modal-width">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title modal-title-color">{{discrb}}</h3>
                            <a type="button" class="btn btn-primary" (click)="closeModal()">close</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- </ng-template>
            </ng-container>
        </owl-carousel-o> -->
    </div>
</div>
<!-------feeling adventurous-------->
<div *ngFor="let fagd of feelingAdventurousGamesData; let i= index">
    <div class="container mt20">
        <div class="row">
            <div class="col-xs-10">
                <div class="title">{{fagd.categoryname}}</div>
            </div>
            <div class="col-xs-2 right mt10"><a [routerLink]="['/view-games/', fagd.categoryid, fagd.categoryname]"
                    class="more">More</a></div>
        </div>
    </div>
    <div class="container mt10">
        <!-- <owl-carousel-o [options]="gamesOwl">
            <ng-container *ngFor="let fag of fagd.content; let i= index">
                <ng-template carouselSlide> -->

        <div class="row" *ngFor="let fag of fagd.content; let i= index">
            <div class="col-xs-4 mt20">
                <a [routerLink]="['/game-play/', fag.gameid, 'home']" (click)="downloadLog(fag.displayname);">
                    <img src="{{fag.previewurl}}" class="round-corner game-icon" width="100%">
                </a>
            </div>
            <div class="col-xs-8 mt20">
                <div class="game-title">{{fag.displayname}}</div>
                <div class="rating">★★★</div>
                <div class="desc" (click)="discribModal(i, fag.description)">{{fag.description}}</div>
                <a href="#" [routerLink]="['/game-play/', fag.gameid, 'home']" (click)="downloadLog(fag.displayname);"
                    class="btn-play">play
                    now</a>
            </div>
            <div class="popup-dis" *ngIf="discrib">
                <div class="modal-dialog modal-width">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title modal-title-color">{{discrb}}</h3>
                            <a type="button" class="btn btn-primary" (click)="closeModal()">close</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- </ng-template>
        </ng-container>
        </owl-carousel-o> -->
    </div>
</div>
<!-------new additions-------->
<div *ngFor="let nagd of newadditionsGamesData; let i= index">
    <div class="container mt20">
        <div class="row">
            <div class="col-xs-10">
                <div class="title">{{nagd.categoryname}}</div>
            </div>
            <div class="col-xs-2 right mt10"><a [routerLink]="['/view-games/', nagd.categoryid, nagd.categoryname]"
                    class="more">More</a></div>
        </div>
    </div>
    <div class="container mt10">
        <!-- <owl-carousel-o [options]="newgamesOwl">
            <ng-container *ngFor="let ngd of nagd.content; let i= index">
                <ng-template carouselSlide> -->

        <div class="row" *ngFor="let ngd of nagd.content; let i= index">
            <div class="col-xs-4 mt20">
                <a [routerLink]="['/game-play/', ngd.gameid, 'home']" (click)="downloadLog(ngd.displayname);">
                    <div><img src="{{ngd.previewurl}}" class="round-corner game-icon" width="100%"></div>
                </a>
            </div>
            <div class="col-xs-8 mt20">
                <div class="game-title mt10">{{ngd.displayname}}</div>
                <div class="rating">★★★</div>
                <div class="desc" (click)="discribModal(i, ngd.description)">{{ngd.description}}</div>
                <a href="#" [routerLink]="['/game-play/', ngd.gameid, 'home']" (click)="downloadLog(ngd.displayname);"
                    class="btn-play">play
                    now</a>
            </div>
            <div class="popup-dis" *ngIf="discrib">
                <div class="modal-dialog modal-width">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title modal-title-color">{{discrb}}</h3>
                            <a type="button" class="btn btn-primary" (click)="closeModal()">close</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </ng-template>
            </ng-container>
        </owl-carousel-o> -->
    </div>
</div>
<!-------action packed-------->
<div *ngFor="let apgd of actionPackedGamesData; let i= index">
    <div class="container mt20">
        <div class="row">
            <div class="col-xs-10">
                <div class="title">{{apgd.categoryname}}</div>
            </div>
            <div class="col-xs-2 right mt10"><a [routerLink]="['/view-games/', apgd.categoryid, apgd.categoryname ]"
                    class="more">More</a></div>
        </div>
    </div>
    <div class="container mt10">
        <!-- <owl-carousel-o [options]="gamesOwl">
            <ng-container *ngFor="let apg of apgd.content; let i= index">
                <ng-template carouselSlide> -->

        <div class="row" *ngFor="let apg of apgd.content; let i= index">
            <div class="col-xs-4 mt20">
                <a [routerLink]="['/game-play/', apg.gameid, 'home']" (click)="downloadLog(apg.displayname);">
                    <img src="{{apg.previewurl}}" class="round-corner game-icon" width="100%">
                </a>
            </div>
            <div class="col-xs-8 mt20">
                <div class="game-title">{{apg.displayname}}</div>
                <div class="rating">★★★</div>
                <div class="desc" (click)="discribModal(i, apg.description)">{{apg.description}}</div>
                <a href="#" [routerLink]="['/game-play/', apg.gameid, 'home']" (click)="downloadLog(apg.displayname);"
                    class="btn-play">play
                    now</a>
            </div>
            <div class="popup-dis" *ngIf="discrib">
                <div class="modal-dialog modal-width">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title modal-title-color">{{discrb}}</h3>
                            <a type="button" class="btn btn-primary" (click)="closeModal()">close</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- </ng-template>
        </ng-container>
        </owl-carousel-o> -->
    </div>
</div>

<div class="container mt20">
    <div class="row">
        <div class="col-xs-12">
            <div class="title">games categories</div>
        </div>

    </div>
</div>
<div class="container mt10">
    <owl-carousel-o [options]="catOwl">
        <ng-container *ngFor="let cat of categoryData; let i= index">
            <ng-template carouselSlide>

                <div class="row">
                    <div class="col-xs-12">
                        <a [routerLink]="['/view-games/', cat.categoryid, cat.categoryname]">
                            <img src="{{cat.imageURL}}" class="round-corner">
                        </a>
                    </div>
                    <div class="col-xs-12 mt10">
                        <div class="game-title center-block">{{cat.categoryname}}</div>
                    </div>

                </div>

            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>



<app-footer></app-footer>

<!-- Modal -->
<!-- <div class="popup" *ngIf="showModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">


<div *ngIf="showModalBox">
    <a type="button" class="btn-play sub" (click)="click()">PLEASE SUBSCRIBE <br>@ 1 DAY FREE TRAIL</a>
</div>
</div>

</div>
</div>
</div> -->

<div class="popup" *ngIf="dayModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title modal-title-color">We are unable to process you request. Kindly try again after
                    few days.</h3>
                <a type="button" class="btn btn-primary" href="https://www.google.com/">OK</a>
            </div>
        </div>
    </div>
</div>

<div class="popup" *ngIf="subModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true" data-dismiss="modal">×</span>
                </button> -->
                <h3 class="modal-title modal-title-color">Thanks to subscribe to the service and make the ultimate use
                    of the premium content.</h3>
                <button type="button" class="btn btn-primary" (click)="closeModal()" aria-hidden="true"
                    data-dismiss="modal">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="popup" *ngIf="wifiModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true" data-dismiss="modal">×</span>
                </button> -->
                <h3 class="modal-title modal-title-color">Please use your Safaricom Internet to access this service.
                </h3>
                <!-- <a type="button" routerLink="/lp" class="btn btn-primary" (click)="closeModal()">OK</a> -->
            </div>
        </div>
    </div>
</div>


<div class="popup" *ngIf="invalidNo">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title modal-title-color">{{msg}}</h3>
                <a type="button" class="btn btn-primary" (click)="closeinvalidModal()">OK</a>
            </div>
        </div>
    </div>
</div>